import debounce from 'lodash/debounce'
const batchpush = {
    state: {
        PushStatus: [],
        TaskDrawerOpen: true
    },
    getters: {},
    mutations: {
        // 新增上传状态（接口名称、请求组标识、机器人id、描述）
        ADD_PUSH_STATUS(state, { name, id, robotids, desc }) {
            let obj = {
                id: id,
                name: name,
                desc: desc,
                list: {},
                start_time: (new Date()).getTime()
            }
            robotids.forEach(robotid=>{
                obj['list'][robotid] = {
                    id: robotid,
                    status: 0,
                    msg: '等待中'
                }
            })
            state.PushStatus.unshift(obj)
        },
        // 更新上传状态（请求组标识、机器人id、状态）
        UPDATE_PUSH_STATUS(state, {id, sub_id, status, msg }){
            state.PushStatus.forEach(item=>{
                if (item.id === id){
                    item['list'][sub_id]['status'] = status
                    item['list'][sub_id]['msg'] = msg
                }
            })
        },
        // 删除上传状态（请求组标识）
        DELETE_PUSH_STATUS(state, { index }) {
            state.PushStatus.splice(index, 1)
        },
        // 清空上传状态
        CLEAR_PUSH_STATUS(state) {
            state.PushStatus = []
        },
        // 任务抽屉打开
        OPEN_TASK_DRAWER(state){
            state.TaskDrawerOpen = true
        },
        // 任务抽屉关闭
        CLOSE_TASK_DRAWER(state) {
            state.TaskDrawerOpen = false
        }
    },
    actions: {
        // 通用推送机器人任务
        BatchpushTask({ commit }, { robotids, apiFun, names, descs, otherFun, otherParams }) {
            // console.log('robotids=', robotids)
            // console.log('descs=', descs)
            // console.log('apiFun=', apiFun)
            // 生成请求标识
            const id = Math.random().toString(36).substr(2)
            let name = names || 'DefaultConfig'
            let desc = descs || '默认任务推送'
            commit('ADD_PUSH_STATUS', { name: name, id: id, robotids: robotids, desc: desc })
            robotids.forEach((val) => {
                const sub_id = val
                commit('UPDATE_PUSH_STATUS', { id, sub_id: sub_id, status: 1, msg: '执行中' })
                apiFun(sub_id).then((res) => {
                    if (res.code === 1) {
                        commit('UPDATE_PUSH_STATUS', { id, sub_id: sub_id, status: 2, msg: '执行成功' })
                        if(otherFun&&otherParams){
                            otherFun(otherParams)
                        }
                    } else {
                        commit('UPDATE_PUSH_STATUS', { id, sub_id: sub_id, status: 3, msg: res.msg })
                    }
                }).catch(error => {
                    commit('UPDATE_PUSH_STATUS', { id, sub_id: sub_id, status: 3, msg: '网络错误' })
                })
            })
        },
        // 任务抽屉开关
        TaskDrawerSwitch({ commit }, { status }) {
            if (status){
                commit('OPEN_TASK_DRAWER')
            }else{
                commit('CLOSE_TASK_DRAWER')
            }
        }
    }
}

export default batchpush
